import React from 'react';
import PropTypes from 'prop-types';
import { UX2 } from '@wsb/guac-widget-core';
import { onServiceClick } from '../utils/onServiceClick';

const SelectServiceButton = ({ service, navigate, renderMode, ...props }) => {
  const {
    Element: { Button }
  } = UX2;

  return (
    <Button.Spotlight onClick={ () => onServiceClick(service, navigate, renderMode) } { ...props } />
  );
};

SelectServiceButton.propTypes = {
  service: PropTypes.object.isRequired,
  navigate: PropTypes.func.isRequired,
  renderMode: PropTypes.string.isRequired
};

export default SelectServiceButton;
